































































































import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import { CampaignFilters } from "@/models/campaign";
import Company from "@/models/company";
import { DashboardTabs, QueryParams } from "@/models/general";
import User from "@/models/user";
import CompanyAPI from "@/services/companies";
import UsersAPI from "@/services/users";
import { CampaignModule } from "@/store/campaign";
import { LayoutModule } from "@/store/layout";
import { cloneDeep, orderBy } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";
import { DashboardModule } from "@/store/dashboard";
import { EventBus } from "@/main";

@Component({ components: { DatePicker } })
export default class DashboardCampaignsFilter extends Vue {
  @Prop() id!: string;
  @Prop() tab!: DashboardTabs;
  statusList = CAMPAIGN_STATUS_LIST;
  companies: Company[] = [];
  users: User[] = [];
  filter: CampaignFilters | null = null;

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  get currentFilter(): CampaignFilters {
    return this.filter as CampaignFilters;
  }

  async created(): Promise<void> {
    LayoutModule.showLoader();
    await this.getCompanies();
    await this.getUsers();
    this.filter = cloneDeep(DashboardModule.getFilter);

    LayoutModule.hideLoader();
  }

  cancel(clean = false): void {
    clean
      ? DashboardModule.setFilter({ id: this.tab.id, filter: this.tab.filter })
      : null;
    LayoutModule.hideRightDrawer();
  }

  apply(): void {
    if (this.filter && !Array.isArray(this.filter?.dateRange)) {
      this.filter.dateRange = [];
    }

    DashboardModule.setFilter({
      id: this.id,
      filter: this.filter as CampaignFilters,
    });
    LayoutModule.hideRightDrawer();
  }

  async getCompanies(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await CompanyAPI.getCompanies(params);
      this.companies = orderBy(r.data, ["name"], ["asc"]);
    } catch (e) {
      console.log(e);
    }
  }

  async getUsers(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await UsersAPI.getUsers(params);
      this.users = orderBy(r.data, ["name"], ["asc"]);
    } catch (e) {
      console.log(e);
    }
  }
}
